var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgExapnd(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    x: 0.23,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#fff",
    fillOpacity: 0.47
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.98 15.75h-4.5v-4.5M2.48 15.75l5.25-5.25M11.48 2.25h4.5v4.5M15.98 2.25L10.73 7.5",
    stroke: "#000",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgExapnd;